import React from 'react';
import './Login.css';
import { Link } from 'react-router-dom';
import RightBanner from './RightBanner';
import logo from "../../assets/images/resetlogo.png";

function AccountRequired() {
    const packageName = localStorage.getItem('selectedPackageName');

    return (
        <>
            <div className="d-flex flex-column flex-lg-row flex-column-fluid">
                <div className="d-flex flex-column flex-lg-row-fluid w-lg-50 p-10 order-1 order-lg-2 right-text text-center">
                    <div className="d-flex flex-center flex-column flex-lg-row-fluid">
                        <a href="https://vertivio.com" title="Logo" className="logo">
                            <img src={logo} title="logo" alt="logo" className="logo-default" />
                        </a>
                        <div className="w-lg-500px p-10">
                            <div className="text-center mb-8">
                                <h1 className="text-gray-900 fw-bolder mb-3">
                                    Account Required
                                </h1>
                                {packageName ? (
                                    <p className="text-gray-500 fw-semibold fs-5">
                                        Create a free account to purchase <strong>{packageName}</strong> and start your RESET journey.
                                    </p>
                                ) : (
                                    <p className="text-gray-500 fw-semibold fs-5">
                                        Create a free account to purchase packages and track your RESET journey.
                                    </p>
                                )}
                            </div>

                            <div className="d-grid mb-4">
                                <Link to="/signup" className="btn btn-primary btn-lg">
                                    Create Free Account
                                </Link>
                            </div>

                            <div className="separator separator-content my-6">
                                <span className="w-125px text-gray-500 fw-semibold fs-7">Already a member?</span>
                            </div>

                            <div className="d-grid mb-4">
                                <Link to="/login" className="btn btn-light-primary btn-lg">
                                    Sign In
                                </Link>
                            </div>

                            <div className="text-center mt-4">
                                <Link to="/theme/packages" className="link-primary fs-6"
                                    onClick={() => localStorage.removeItem('selectedPackageId')}>
                                    ← Back to Packages
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
                <RightBanner />
            </div>
        </>
    );
}

export default AccountRequired;
